/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntercomUserDto } from '../models/IntercomUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntercomService {
    /**
     * Get intercom configuration
     * Fetch the intercom configuration for a user.
     * @returns IntercomUserDto Successfully fetched intercom configuration
     * @throws ApiError
     */
    public static getIntercomConfiguration(): CancelablePromise<IntercomUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/intercom',
            errors: {
                404: `Intercom configuration not found`,
            },
        });
    }
    /**
     * Get article by ID
     * Fetch an article from Intercom by its ID.
     * @returns string Successfully fetched article
     * @throws ApiError
     */
    public static getArticleById({
        id,
    }: {
        id: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/intercom/article/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Article not found`,
            },
        });
    }
}
